import { createContext } from 'react'

export type BlurryBackgroundContextType = true

const BlurryBackgroundContext = createContext<
  BlurryBackgroundContextType | undefined
>(undefined)

export default BlurryBackgroundContext
